/**
 * removes dashes ("-") from the given input string
 * @param {string} s
 * @returns {string} - string with dashes removed
 */
export var stripDashes = function stripDashes(s) {
  return s.replace(/-/gi, '');
};

/**
 * converts the given input string to upper case and removes all white spaces
 * @param {string} str
 * @returns {string} - string with all white spaces removed and converted to upper case
 */
export var stripWhiteSpaceToUpperCase = function stripWhiteSpaceToUpperCase(str) {
  return str.toUpperCase().replace(/\s/g, '');
};

/**
 * compares two strings, ignoring casing and spacing.
 * @param {string} str1
 * @param {string} str2
 * @returns {boolean} true if two strings are identical, false otherwise
 */
export var strCmpIgnoreSpaceAndCasing = function strCmpIgnoreSpaceAndCasing(str1, str2) {
  return stripWhiteSpaceToUpperCase(str1) === stripWhiteSpaceToUpperCase(str2);
};

/**
 * removes excessive space from the given input string
 * @param {string} value
 * @returns {string} - string with excessive space removed
 */
export var removeExcessiveSpace = function removeExcessiveSpace(value) {
  var excessiveSpaceRegex = /( +)/g;
  var removeExtraSpace = value.trim();
  return removeExtraSpace.replace(excessiveSpaceRegex, ' ');
};
export var whiteListRegexOnlyLettersAndCertainChars = /[^a-zA-ZÀ-ž `'~.-]/g;
export var whiteListRegex = /[^a-zA-ZÀ-ž `'~.-]/g;
export var whiteListNumeric = /^\d+$/;

/**
 * removes any characters from the string that arent in the whitelist
 * @param {string} value
 * @returns {string} - string with only characters in the whitelist
 */
export var sanitizeString = function sanitizeString(value) {
  return value.replace(whiteListRegex, '').trim();
};

/**
 * parses a string by replacing placeholders in the form {key} with corresponding values a provided StringMap
 * https://stackoverflow.com/questions/7975005/format-a-javascript-string-using-placeholders-and-an-object-of-substitutions/7975025#7975025
 * @param {string} message
 * @param {StringMap<string>} value
 * @returns {string} - a new string with placeholders replaced with values
 */
export var parseString = function parseString(message, value) {
  return message.replace(/{(\w+)}/g, function (valueWithDelimiters, valueWithoutDelimiters) {
    return Object.prototype.hasOwnProperty.call(value, valueWithoutDelimiters) ? value[valueWithoutDelimiters] : valueWithDelimiters;
  });
};

/**
 * parses a string by replacing a specified delimter with a given value
 * @param {string} str
 * @param {string} value
 * @param {string} delimiter
 * @returns {string} - a new string with the delimiter replaced with the value
 */
export var parseValueIntoString = function parseValueIntoString(str, value, delimiter) {
  return str.split(delimiter).join(value);
};

/**
 * checks if a string is empty, null, or undefined
 * @param {string | undefined} str
 * @returns {boolean} - true if string is empty, null, or undefined, false otherwise
 */
export var isEmpty = function isEmpty(str) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (str === null || str === '' || str === undefined) {
    return true;
  }
  return false;
};

/**
 * parses and formats content by replacing placeholders, adjusting pricing info, and transforming specific HTML elements for improved display
 * @param {{ __html: string }} content
 * @param {string} price
 * @returns {{ __html: string }} - an object with the parsed and formatted content
 */
export function parseTermsContent(content, price) {
  var __html = content.__html;
  return {
    __html: __html.split('${price}').join(price).replace(/\n/g, '').replace(/<p> *<b>/g, '<h3>').replace(/<\/b> *<\/p>/g, '</h3>').replace(/<p> *<u>/g, "<h4 style='text-decoration: underline;font-weight: normal;' >").replace(/<\/u> *<\/p>/g, '</h4>')
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/StringUtils.js
// module id = 633
// module chunks = 11